import type { UpdateType } from "@/lib/updateType";

/**
 * Treść komunikatu sukcesu po wysłaniu zgłoszenia.
 * Dopasowana do typu zgłoszenia: nowe schronisko / potrzeby / dane / pełna aktualizacja.
 */
export function getSubmitSuccessMessage(opts: {
  isNewShelter: boolean;
  updateType: UpdateType;
}): string {
  if (opts.isNewShelter) {
    return "Nowe schronisko pojawi się na mapie po weryfikacji administratora - zwykle do 24h.";
  }
  if (opts.updateType === "needs") {
    return "Zaktualizowane potrzeby pojawią się w profilu schroniska po weryfikacji administratora - zwykle do 24h.";
  }
  if (opts.updateType === "info") {
    return "Zmienione dane schroniska pojawią się po weryfikacji administratora - zwykle do 24h.";
  }
  return "Twoja aktualizacja schroniska pojawi się po weryfikacji administratora - zwykle do 24h.";
}

export const QUICK_UPDATE_SUCCESS_MESSAGE =
  "Zaktualizowane potrzeby pojawią się w profilu schroniska po weryfikacji administratora - zwykle do 24h.";

export const SUCCESS_TITLE = "Dziękujemy! 🎉";
